import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useState } from 'react';

interface SellerTopNavigationProps {
  className?: string;
}

export function SellerTopNavigation({ className = '' }: SellerTopNavigationProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = async () => {
    await signOut();
    setShowDropdown(false);
    navigate('/login');
  };

  // 판매자용 네비게이션 아이템
  const navItems = [
    { id: 'home', name: '홈', path: '/seller/home' },
    { id: 'store', name: '내 가게', path: '/seller/store' },
    { id: 'mypage', name: '마이페이지', path: '/seller/mypage' }
  ];

  const isActive = (path: string) => {
    return location.pathname.startsWith(path);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 h-[72px] bg-white border-b border-[#DEDEDE] z-50 ${className}`}>
      <div className="h-full px-6 flex items-center justify-between">
        {/* Left Section - Logo and Navigation */}
        <div className="flex items-center gap-10">
          {/* Logo and Brand */}
          <button 
            onClick={() => navigate('/seller/home')}
            className="flex items-center hover:opacity-80 transition-opacity"
          >
            <div className="flex items-center gap-2">
              <img 
                src="/icons/brand_icon.svg" 
                alt="ECODEAL" 
                className="h-10"
              />
              <span className="font-bold text-2xl text-[#86DB89]">ECODEAL</span>
              <span className="text-sm font-semibold text-gray-600 ml-2">판매자</span>
            </div>
          </button>

          {/* Navigation Menu */}
          <ul className="flex items-center gap-10">
            {navItems.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => navigate(item.path)}
                  className={`text-[22px] font-bold transition-colors ${
                    isActive(item.path)
                      ? 'text-[#86DB89]'
                      : 'text-gray-700 hover:text-[#86DB89]'
                  }`}
                >
                  {item.name}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Section - Auth */}
        <div className="flex items-center gap-6">
          {user ? (
            <div className="relative">
              <button
                onClick={() => setShowDropdown(!showDropdown)}
                className="flex items-center gap-2 hover:opacity-80 transition-opacity"
              >
                <div className="w-8 h-8 rounded-full bg-[#86DB89] flex items-center justify-center text-white text-sm font-semibold">
                  {user.name?.charAt(0).toUpperCase() || user.email?.charAt(0).toUpperCase() || 'S'}
                </div>
                <span className="text-gray-700">
                  {user.name || user.email || 'Seller'}
                </span>
                <svg
                  className={`w-4 h-4 transition-transform ${showDropdown ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {/* Dropdown Menu */}
              {showDropdown && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2">
                  <button
                    onClick={() => {
                      navigate('/seller/settings');
                      setShowDropdown(false);
                    }}
                    className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-50"
                  >
                    설정
                  </button>
                  <button
                    onClick={handleLogout}
                    className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-50"
                  >
                    로그아웃
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <button
                onClick={() => navigate('/signup-select')}
                className="text-[18px] font-semibold text-gray-700 hover:text-[#86DB89] transition-colors"
              >
                회원가입
              </button>
              <button
                onClick={() => navigate('/login')}
                className="px-6 py-2 bg-[#86DB89] text-white text-[18px] font-semibold rounded-lg hover:bg-[#76CB79] transition-colors"
              >
                로그인
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}